var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _rect3, _path11, _rect4, _path12, _rect5, _path13, _rect6, _path14, _rect7, _path15, _rect8, _path16, _rect9, _path17, _rect10, _path18, _rect11, _path19, _rect12, _rect13, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroHomeMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 953,
    height: 418,
    viewBox: "0 0 953 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 488.5,
    cy: 131.5,
    r: 128.5,
    fill: "#D2B487"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 145.38C0 145.38 70.1405 99.0094 175.709 115.034C260.751 127.943 258.487 139.244 363.993 145.38C447.949 150.263 710.779 111 788.541 111C866.303 111 953 145.38 953 145.38V418H0V145.38Z",
    fill: "#F2EBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 235.062C0 235.062 152.622 213.994 261.413 214.152C368.267 214.308 402.378 256.447 517.532 235.062C591.075 221.404 750.488 209.117 799.461 214.152C848.435 219.187 953 235.062 953 235.062V418H0V235.062Z",
    fill: "#E4D7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02 218.809C707.77 218.809 708.07 218.809 728.636 218.809C614.755 227.711 577.306 412.5 577.306 412.5H480C480 412.5 594.802 218.809 697.02 218.809Z",
    fill: "#F2EBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M800.187 181.917C800.187 181.087 799.632 180.36 798.833 180.141L745.715 165.551C745.489 165.489 745.277 165.384 745.09 165.242L712.566 140.574C711.674 139.897 710.389 140.166 709.844 141.145L690.499 175.855C690.346 176.13 690.266 176.438 690.266 176.752V217.552C690.266 218.569 691.091 219.394 692.108 219.394H798.345C799.362 219.394 800.187 218.569 800.187 217.552V181.917Z",
    fill: "#C08A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M800.392 182.057C800.392 181.216 799.823 180.483 799.01 180.273L745.979 166.605C744.813 166.305 743.677 167.185 743.677 168.389V217.669C743.677 218.686 744.502 219.511 745.519 219.511H798.55C799.567 219.511 800.392 218.686 800.392 217.669V182.057Z",
    fill: "#B57878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M769.165 158.417C769.117 158.385 769.065 158.36 769.01 158.342L711.627 140.129C710.965 139.919 710.518 140.798 711.078 141.209L745.684 166.621C745.747 166.667 745.818 166.701 745.893 166.721L800.929 181.056C801.598 181.23 802 180.335 801.424 179.951L769.165 158.417Z",
    fill: "#E4D7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M953 331.541C953 331.541 779.607 298.144 691.587 318.714C594.224 341.468 568.506 322.849 449.697 325.308C327.925 327.828 243.214 307 165.12 307C87.0274 307 -2.09808e-05 331.541 -2.09808e-05 331.541V418H953V331.541Z",
    fill: "#E2DCD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.37 96.9998H156.821L154.683 58.0658H147.507L145.37 96.9998Z",
    fill: "#6D6363"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(1 0 0 -1 150.027 66.3106)",
    fill: "#6D6363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.82 0.809875H145.369L147.507 39.7439H154.683L156.82 0.809875Z",
    fill: "#6D6363"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(-1 0 0 1 152.24 30.583)",
    fill: "#6D6363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103 54.6304V43.1792L141.934 45.3167V52.4928L103 54.6304Z",
    fill: "#6D6363"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.689,
    y: 49.9736,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(-90 133.689 49.9736)",
    fill: "#6D6363"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.19 43.1792V54.6303L160.256 52.4928V45.3167L199.19 43.1792Z",
    fill: "#6D6363"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169.417,
    y: 47.7597,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(90 169.417 47.7597)",
    fill: "#6D6363"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.883 77.911L195.609 67.994L160.822 50.3782L157.234 56.5928L189.883 77.911Z",
    fill: "#6D6363"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 165.634 58.5336)",
    fill: "#6D6363"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.306 19.899L106.58 29.816L141.367 47.4318L144.955 41.2171L112.306 19.899Z",
    fill: "#6D6363"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 135.8 38.7523)",
    fill: "#6D6363"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.306 77.911L106.581 67.994L141.367 50.3782L144.955 56.5928L112.306 77.911Z",
    fill: "#6D6363"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 136.556,
    y: 58.5336,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(-120 136.556 58.5336)",
    fill: "#6D6363"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.884 19.899L195.609 29.816L160.823 47.4318L157.235 41.2171L189.884 19.899Z",
    fill: "#6D6363"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 166.389,
    y: 38.7523,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(60 166.389 38.7523)",
    fill: "#6D6363"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.184 93.4192L180.101 87.6936L158.783 55.0446L152.568 58.6326L170.184 93.4192Z",
    fill: "#6D6363"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 158.873 64.5134)",
    fill: "#6D6363"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.006 4.39059L122.089 10.1162L143.407 42.7652L149.621 39.1772L132.006 4.39059Z",
    fill: "#6D6363"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 142.925 32.4651)",
    fill: "#6D6363"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.006 93.4192L122.089 87.6936L143.407 55.0446L149.621 58.6326L132.006 93.4192Z",
    fill: "#6D6363"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 143.317,
    y: 64.5133,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(-150 143.317 64.5133)",
    fill: "#6D6363"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.184 4.39059L180.101 10.1162L158.783 42.7652L152.568 39.1772L170.184 4.39059Z",
    fill: "#6D6363"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 159.264,
    y: 32.4651,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(30 159.264 32.4651)",
    fill: "#6D6363"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 150.152,
    y: 47.9618,
    width: 67.8987,
    height: 1.88608,
    fill: "#6D6363"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M214.278 38.5314L252 34.7592L245.399 46.0757L252 58.3352L214.278 55.506V38.5314Z",
    fill: "#6D6363"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M151.095 173.386V146.038M151.095 146.038L115.981 172.148C115.44 172.55 114.697 172.038 114.881 171.389L126.576 130.006M151.095 146.038L175.614 130.006M151.095 146.038V113.032M151.095 146.038L126.576 130.006M126.576 130.006L188.043 172.207C188.599 172.589 189.323 172.048 189.114 171.406L175.614 130.006M126.576 130.006L136.006 99.829M126.576 130.006L151.095 113.032M126.576 130.006H175.614M175.614 130.006L151.095 113.032M175.614 130.006L166.183 99.829M136.006 99.829L151.095 113.032M136.006 99.829L142.316 78.1391M136.006 99.829L159.873 78.1391M151.095 113.032L166.183 99.829M151.095 113.032V47.9619M166.183 99.829L142.316 78.1391M166.183 99.829L159.873 78.1391M151.095 47.9619L142.316 78.1391M151.095 47.9619L159.873 78.1391",
    stroke: "#6D6363",
    strokeWidth: 0.706162
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHomeMd);
export default __webpack_public_path__ + "static/media/hero-home-md.0641905b.svg";
export { ForwardRef as ReactComponent };